<template>
  <div>
    <TopHeader :showSearchBox="false" />
    <div class="uc-bannerSearch">
      <div class="container">
        <section class="g-filterSearch uc-pt40">
          <div class="search">
            <input
              type="text"
              placeholder="请输入您想搜索的资源"
              class="uc-input"
              v-model.trim="keyword"
              @keyup.enter="handleSearchClick"
            />
            <a @click="handleSearchClick" class="uc-btn blue"
              ><i class="uc-font uc-search"></i
            ></a>
          </div>
        </section>
      </div>
    </div>

    <section class="container-fluid g-centerTabSearch">
      <div class="container">
        <div class="row">
          <div class="col-24 filter">
            <div class="menu-tab">
              <div
                :class="tab == 'tab1' ? 'item on' : 'item'"
                @click="
                  tab = 'tab1';
                  loadData();
                "
              >
                课程
              </div>
              <div
                :class="tab == 'tab2' ? 'item on' : 'item'"
                @click="
                  tab = 'tab2';
                  loadData();
                "
              >
                培训班
              </div>
              <div
                :class="tab == 'tab3' ? 'item on' : 'item'"
                @click="
                  tab = 'tab3';
                  loadData();
                "
              >
                案例库
              </div>
              <div
                :class="tab == 'tab4' ? 'item on' : 'item'"
                @click="
                  tab = 'tab4';
                  loadData();
                "
              >
                考试
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-show="tab == 'tab1'">
      <section class="container-fluid uc-homePart1 uc-bg uc-pt20">
        <div class="container">
          <div class="content-empty" v-show="courseList.total_count == 0">
            <div class="emptyimg-box"></div>
            <p>暂无相关内容</p>
          </div>

          <div class="row list">
            <div
              v-for="(item, index) in courseList.items"
              :key="index"
              class="col-6"
            >
              <div class="item">
                <router-link
                  :to="{
                    name: 'CourseDetails',
                    params: { id: item.id },
                  }"
                  class="con"
                  target="_blank"
                >
                  <div class="img-box">
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../assets/images/default-kc.png" />
                      </div>
                    </el-image>
                  </div>
                  <div class="btm">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.name"
                    >
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <div class="txt">
                      {{ item.lecturer_name || '无讲师' }}
                      | {{ item.period }}分钟 | {{ item.score }}学分
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <el-pagination
            class="uc-prvNxt"
            background
            layout="prev, pager, next"
            hide-on-single-page
            :current-page="queryCourse.pageIndex"
            :page-size="queryCourse.pageSize"
            :total="courseList.total_count"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </section>
    </div>

    <div v-show="tab == 'tab2'">
      <section class="container-fluid uc-homePart1 uc-bg uc-pt20">
        <div class="container">
          <div class="content-empty" v-show="trainClassList.total_count == 0">
            <div class="emptyimg-box"></div>
            <p>暂无相关内容</p>
          </div>

          <div class="row list">
            <div
              v-for="(item, index) in trainClassList.items"
              :key="index"
              class="col-6"
            >
              <div class="item">
                <router-link
                  :to="{
                    name: 'TrainClassDetails',
                    params: { id: item.id },
                  }"
                  class="con"
                  target="_blank"
                >
                  <div class="img-box">
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../assets/images/default-hd.png" />
                      </div>
                    </el-image>
                  </div>
                  <div class="btm">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.name"
                    >
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <div class="txt">共{{ item.course_count }}课</div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <el-pagination
            class="uc-prvNxt"
            background
            layout="prev, pager, next"
            hide-on-single-page
            :current-page="queryTrainClass.pageIndex"
            :page-size="queryTrainClass.pageSize"
            :total="trainClassList.total_count"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </section>
    </div>

    <div v-show="tab == 'tab3'">
      <section class="container-fluid uc-homePart1 uc-bg uc-pt20">
        <div class="container">
          <div class="content-empty" v-show="KnowledgeList.total_count == 0">
            <div class="emptyimg-box"></div>
            <p>暂无相关内容</p>
          </div>

          <div class="row list">
            <div
              v-for="(item, index) in KnowledgeList.items"
              :key="index"
              class="col-6"
            >
              <div class="item">
                <router-link
                  :to="{
                    name: 'KnowledgeDetails',
                    params: { id: item.id },
                  }"
                  class="con"
                  target="_blank"
                >
                  <div class="img-box">
                    <img :src="item.cover" />
                  </div>
                  <div class="btm">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.name"
                    >
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <div class="txt">{{ item.create_time }}</div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <el-pagination
            class="uc-prvNxt"
            background
            layout="prev, pager, next"
            hide-on-single-page
            :current-page="queryKnowledge.pageIndex"
            :page-size="queryKnowledge.pageSize"
            :total="KnowledgeList.total_count"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </section>
    </div>

    <div v-show="tab == 'tab4'">
      <section class="container-fluid uc-examList uc-bg uc-pt20">
        <div class="container">
          <div class="content-empty" v-show="examList.total_count == 0">
            <div class="emptyimg-box"></div>
            <p>暂无相关内容</p>
          </div>

          <div class="row">
            <div
              v-for="(item, index) in examList.items"
              :key="index"
              class="item"
            >
              <router-link
                to=""
                class="title"
                @click.native="handleItemClick(item)"
              >
                <img
                  src="../assets/images/icon130.png"
                  class="uc-icon20"
                  v-if="item.exam_status == 0"
                />
                <img
                  src="../assets/images/icon131.png"
                  class="uc-icon20"
                  v-if="item.exam_status == 1 && item.is_pass == 0"
                />
                <img
                  src="../assets/images/icon132.png"
                  class="uc-icon20"
                  v-if="item.exam_status == 1 && item.is_pass == 1"
                />
                <img
                  src="../assets/images/icon133.png"
                  class="uc-icon20"
                  v-if="item.exam_status == 2"
                />
                <div class="c">{{ item.name }}</div>
                <span class="uc-font uc-next"></span>
              </router-link>
              <div class="con">
                <div class="sub-item">开始时间：{{ item.start_time }}</div>
                <div class="sub-item">结束时间：{{ item.end_time }}</div>
                <div class="sub-item">
                  考试时长：{{
                    item.duration == 0 ? '不限' : item.duration + '分钟'
                  }}
                </div>
                <div class="sub-item">试卷总分：{{ item.total_score }}分</div>
                <div class="sub-item">通过分数：{{ item.pass_score }}分</div>
                <div class="sub-item">
                  可考次数：{{
                    item.allow_times == 0 ? '不限' : item.allow_times + '次'
                  }}
                </div>
                <div class="sub-item">
                  出题方式：{{ item.question_way == 1 ? '随机' : '固定' }}
                </div>
                <div class="sub-item">
                  评分方式：{{ (item.score_way = 1 ? '自动' : '手工') }}
                </div>
                <div class="sub-item">
                  出卷人员：{{ item.create_first_name }}
                </div>
              </div>
              <div
                class="operate"
                v-if="queryExam.status == 1 && item.config > 0"
              >
                <router-link
                  :to="{
                    name: 'ExamStatistics',
                    params: { id: item.answer_id },
                  }"
                  target="_blank"
                  class="uc-btn blue-plain"
                  hover-class="none"
                  v-if="(item.config & 2) == 2"
                  >查看分数</router-link
                >
                <router-link
                  :to="{ name: 'ExamWrong', params: { id: item.answer_id } }"
                  target="_blank"
                  class="uc-btn blue-plain"
                  hover-class="none"
                  v-if="(item.config & 8) == 8"
                  >查看错题</router-link
                >
                <router-link
                  :to="{ name: 'ExamRecord', params: { id: item.answer_id } }"
                  target="_blank"
                  class="uc-btn blue-plain"
                  hover-class="none"
                  v-if="(item.config & 1) == 1"
                  >查看答案</router-link
                >
                <router-link
                  :to="{ name: 'ExamRanking', params: { id: item.id } }"
                  target="_blank"
                  class="uc-btn blue-plain"
                  hover-class="none"
                  v-if="(item.config & 4) == 4"
                  >查看排名</router-link
                >
              </div>
            </div>
          </div>
          <el-pagination
            class="uc-prvNxt"
            background
            layout="prev, pager, next"
            hide-on-single-page
            :current-page="queryExam.pageIndex"
            :page-size="queryExam.pageSize"
            :total="examList.total_count"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </section>
    </div>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'Search',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      tab: 'tab1',
      keyword: this.$route.query.keyword,
      orderby: this.$route.query.orderby,
      queryCourse: {
        tagId: undefined,
        pageIndex: 1,
        pageSize: 8,
        orderby: 0,
        keyword: undefined,
      },
      queryTrainClass: {
        catalogId: undefined,
        status: -1,
        pageIndex: 1,
        pageSize: 8,
        keyword: undefined,
      },
      queryKnowledge: {
        catalogId: undefined,
        tagId: undefined,
        pageIndex: 1,
        pageSize: 8,
        orderby: 0,
        keyword: undefined,
      },
      queryExam: {
        status: -1,
        pageIndex: 1,
        pageSize: 8,
        keyword: undefined,
      },
      courseList: {},
      trainClassList: {},
      KnowledgeList: {},
      examList: {},
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    $route() {
      this.keyword = this.$route.query.keyword;
      this.orderby = this.$route.query.orderby;
      this.loadData();
    },
  },
  methods: {
    loadData() {
      if (this.tab === 'tab1') {
        this.queryCourse.keyword = this.keyword;
        this.queryCourse.orderby = this.orderby;
        this.getCourses();
      } else if (this.tab === 'tab2') {
        this.queryTrainClass.keyword = this.keyword;
        this.getTrainClasses();
      } else if (this.tab === 'tab3') {
        this.queryKnowledge.keyword = this.keyword;
        this.getKnowledges();
      } else {
        this.queryExam.keyword = this.keyword;
        this.getPapers();
      }
    },
    async getCourses() {
      const response = await this.$api.course.getCourses(this.queryCourse);
      this.courseList = response.data.data;
    },
    async getTrainClasses() {
      const response = await this.$api.train.getTrainClasses(
        this.queryTrainClass
      );
      this.trainClassList = response.data.data;
    },
    async getKnowledges() {
      const response = await this.$api.knowledge.getKnowledges(
        this.queryKnowledge
      );
      this.KnowledgeList = response.data.data;
    },
    async getPapers() {
      const response = await this.$api.exam.getPapers(this.queryExam);
      this.examList = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      if (this.tab === 'tab1') {
        this.queryCourse.pageIndex = val;
      } else if (this.tab === 'tab2') {
        this.queryTrainClass.pageIndex = val;
      } else if (this.tab === 'tab3') {
        this.queryKnowledge.pageIndex = val;
      } else {
        this.queryExam.pageIndex = val;
      }
      this.loadData();
    },
    // 跳转
    handleItemClick(item) {
      switch (item.paper_status) {
        case 0:
          this.$message({ message: '考试未开始' });
          break;
        case 1:
          // 可考次数不限 或 可考次数大于已考次数 才可以进入考试
          if (item.allow_times === 0 || item.allow_times > item.answer_times) {
            this.$confirm(`确定要参加【${item.name}】考试吗？`, '提示', {
              type: 'info',
            }).then(() => {
              window.open('/exam/answer/' + item.id, 'ExamAnswer');
            });
          } else {
            this.$message({ message: '考试次数超出限制' });
          }
          break;
        case 2:
          this.$message({ message: '考试已结束' });
          break;
      }
    },
    handleSearchClick() {
      if (!this.keyword) {
        this.$message({ type: 'warning', message: '请输入搜索关键字' });
      } else {
        this.loadData();
      }
    },
  },
};
</script>
